var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWingmateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 116.98 66.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#New_Gradient_Swatch_1);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    "data-name": "New Gradient Swatch 1",
    x1: 9.33,
    y1: 2.29,
    x2: 107.65,
    y2: 59.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff911e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc1473"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.34,22.62l-4.23,4.23c-1.46,1.46-1.46,3.82,0,5.28.57.57,1.29.91,2.03,1.04.29.08.59.13.9.13,2.22,0,4.03,1.81,4.03,4.03,0,16.07,13.08,29.15,29.15,29.15,1.94,0,3.52-1.58,3.52-3.52s-1.57-3.52-3.52-3.52c-12.19,0-22.11-9.92-22.11-22.11,0-3.77-1.9-7.11-4.79-9.11l.31-.31c1.88-1.88,4.94-1.88,6.82,0l5.41,5.41c.73.73,1.69,1.09,2.64,1.09s1.91-.36,2.64-1.09c1.46-1.46,1.46-3.82,0-5.28l-5.41-5.41c-2.4-2.4-5.54-3.59-8.69-3.59s-6.3,1.2-8.69,3.59m34.98-4.84c-1.59,1.03-1.94,3.02-.8,4.44,4.06,5.05,4.06,11.84,0,16.9-1.14,1.43-.79,3.42.8,4.44.63.41,1.35.6,2.07.6,1.1,0,2.18-.46,2.87-1.32,5.85-7.28,5.85-17.07,0-24.35-.69-.86-1.78-1.32-2.87-1.32-.72,0-1.44.2-2.07.6m13.83-8.43c-1.58,1.03-1.94,3.02-.8,4.44,8.12,10.11,8.12,23.69,0,33.77-1.15,1.42-.79,3.41.79,4.44.63.41,1.35.6,2.07.6,1.1,0,2.18-.46,2.87-1.32,9.9-12.32,9.9-28.89,0-41.23-.69-.86-1.77-1.32-2.87-1.32-.72,0-1.44.2-2.07.6m-62.27.72c-9.9,12.33-9.9,28.9,0,41.22.69.86,1.78,1.32,2.87,1.32.72,0,1.44-.19,2.07-.6,1.59-1.03,1.94-3.02.8-4.44-8.11-10.1-8.11-23.67,0-33.77,1.15-1.43.79-3.42-.8-4.44-.63-.41-1.35-.6-2.07-.6-1.1,0-2.18.46-2.87,1.32M101.47.6c-1.58,1.03-1.94,3.02-.8,4.44,12.3,15.33,12.3,35.92,0,51.24-1.14,1.43-.79,3.42.8,4.44.63.41,1.35.6,2.07.6,1.1,0,2.18-.46,2.87-1.32,14.09-17.55,14.09-41.14,0-58.7C105.72.46,104.64,0,103.54,0c-.72,0-1.44.2-2.07.6M10.57,1.32c-14.09,17.55-14.09,41.14,0,58.7.69.86,1.78,1.32,2.87,1.32.72,0,1.44-.19,2.07-.6,1.59-1.03,1.94-3.02.8-4.44-12.3-15.32-12.3-35.92,0-51.24,1.14-1.43.79-3.42-.8-4.44-.63-.41-1.35-.6-2.07-.6-1.1,0-2.18.46-2.87,1.32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWingmateIcon);
export default __webpack_public_path__ + "static/media/wingmate-icon.b13cbf79d90ddc8a2149e7dc1db60bf9.svg";
export { ForwardRef as ReactComponent };